import React from "react"
import ArticleLastListBlock from "../../blocks/articles-last-list-block/ArticleLastListBlock"
import Section from "../../../../core/layout/main/section/Section"

function ArticlesFrontPage({ articles, page, label }) {
  return (
    <Section 
    className={"ArticlesFrontPage"}
    container>
      <ArticleLastListBlock
        bigTitle={label}
        articles={articles}
        page={page}
      />
    </Section>
  )
}
export const name = "ArticlesFrontPage"

export const init = (componentData, pageContext) => {

  return (
    <ArticlesFrontPage
      key={componentData.id}
      articles={pageContext.articlesData}
     //articles={[]}
      page={componentData.page?.data?.attributes?.route}
      label={componentData.label}
    />
  )
}

export default ArticlesFrontPage
